// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__Zkzay {
  background: white;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 0 1rem 1.5rem;
  padding: 1rem;
  width: calc(100% - 2rem);
}

.styles_loading__LPKYM {
  align-items: center;
  display: flex;
  height: 80vh;
  justify-content: center;
  width: 100vw;
}

.styles_header__eTWHl {
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.styles_title__Ppa9W {
  align-items: center;
  color: #18316e;
  display: flex;
  font-family: "Abhaya Libre";
  font-size: 2rem;
  font-weight: 600;
  flex: 1 1;
}

.styles_filtrosContainer__5LK3o {
  align-items: center;
  display: flex;
  width: 60%;
}

.styles_iconFilter__Vdypo {
  color: #18316e;
  font-size: 2rem;
  margin-right: 0.5rem;
}

.styles_tipoVisualizacaoContainer__wxvLi {
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0;
}

.styles_iconVisualizacoes__KbZWl {
  color: #18316e !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

.styles_iconVisualizacoes__KbZWl:hover {
  background-color: #bebebe !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  padding: 0.5rem !important;
}

.styles_iconVisualizacoesActive__NIMdj {
  background-color: #919191 !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

.styles_visualizacaoContainer__DLUCN {
  padding: 1rem;
  overflow: visible;
  min-height: 0;
}

@media (max-width: 780px) {
  .styles_container__Zkzay {
    margin: 0 1rem;
  }

  .styles_title__Ppa9W {
    align-self: flex-start;
  }

  .styles_filtrosContainer__5LK3o {
    width: 100%;
    margin-bottom: 8px;
  }

  .styles_header__eTWHl {
    flex-direction: column;
  }
}

.styles_iconeAdd__EyFFr {
  color: #fff;
  font-size: 2rem;
}

.styles_iconeAdd__EyFFr:hover {
  color: #18316e;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ExtratorRelatorios/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\n  background: white;\n  border-radius: 5px;\n  box-sizing: border-box;\n  margin: 0 1rem 1.5rem;\n  padding: 1rem;\n  width: calc(100% - 2rem);\n}\n\n.loading {\n  align-items: center;\n  display: flex;\n  height: 80vh;\n  justify-content: center;\n  width: 100vw;\n}\n\n.header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.title {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  font-family: \"Abhaya Libre\";\n  font-size: 2rem;\n  font-weight: 600;\n  flex: 1;\n}\n\n.filtrosContainer {\n  align-items: center;\n  display: flex;\n  width: 60%;\n}\n\n.iconFilter {\n  color: #18316e;\n  font-size: 2rem;\n  margin-right: 0.5rem;\n}\n\n.tipoVisualizacaoContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1rem 0;\n}\n\n.iconVisualizacoes {\n  color: #18316e !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n.iconVisualizacoes:hover {\n  background-color: #bebebe !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  padding: 0.5rem !important;\n}\n\n.iconVisualizacoesActive {\n  background-color: #919191 !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n.visualizacaoContainer {\n  padding: 1rem;\n  overflow: visible;\n  min-height: 0;\n}\n\n@media (max-width: 780px) {\n  .container {\n    margin: 0 1rem;\n  }\n\n  .title {\n    align-self: flex-start;\n  }\n\n  .filtrosContainer {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n\n  .header {\n    flex-direction: column;\n  }\n}\n\n.iconeAdd {\n  color: #fff;\n  font-size: 2rem;\n}\n\n.iconeAdd:hover {\n  color: #18316e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__Zkzay`,
	"loading": `styles_loading__LPKYM`,
	"header": `styles_header__eTWHl`,
	"title": `styles_title__Ppa9W`,
	"filtrosContainer": `styles_filtrosContainer__5LK3o`,
	"iconFilter": `styles_iconFilter__Vdypo`,
	"tipoVisualizacaoContainer": `styles_tipoVisualizacaoContainer__wxvLi`,
	"iconVisualizacoes": `styles_iconVisualizacoes__KbZWl`,
	"iconVisualizacoesActive": `styles_iconVisualizacoesActive__NIMdj`,
	"visualizacaoContainer": `styles_visualizacaoContainer__DLUCN`,
	"iconeAdd": `styles_iconeAdd__EyFFr`
};
export default ___CSS_LOADER_EXPORT___;
